import { Group } from "@mantine/core";
import { useToast } from "../../../mantine/notifications/useToast";
import { TodoStatus } from "../../../utils/backend-types";
import { LoadOrError } from "../../LoadOrError/LoadOrError";
import { useTodos } from "../../Todos/hooks/useTodos";
import { Mode } from "../../Todos/Todos.types";
import { TodosDueSoon } from "./TodosDueSoon";
import { TodosProgress } from "./TodosProgress";

interface TodoStatsProps {
  variantId: number;
}

function TodoStats({ variantId }: TodoStatsProps) {
  const { showErrorToast } = useToast();
  const {
    todos,
    isLoading: todosLoading,
    error: todosError
  } = useTodos({
    mode: Mode.Normal,
    variantId,
    onUpdateError: (error) => showErrorToast(error)
  });

  const allTodos = todos ?? [];
  const openTodos = allTodos.filter((todo) => todo.status === TodoStatus.Open);
  const doneTodos = allTodos.filter((todo) => todo.status === TodoStatus.Done);

  return (
    <LoadOrError
      className="TodoStats"
      error={todosError}
      loading={todosLoading}
    >
      {todos && (
        <Group mb="lg" wrap="nowrap">
          <TodosDueSoon todos={openTodos} />
          {openTodos.length + doneTodos.length > 0 && (
            <TodosProgress
              done={doneTodos.length}
              total={openTodos.length + doneTodos.length}
            />
          )}
        </Group>
      )}
    </LoadOrError>
  );
}

export { TodoStats, TodoStatsProps };
